<template>
    <main id="page" class="home">
        <b-container>
            <b-row>
                <b-col md="6" offset-md="3">
                    <div class="home-panel">
                        <div class="home-logo">
                            <b-link :to="{ name: 'home' }">
                                <logo></logo>
                            </b-link>
                        </div>
                        <div class="home-buttons">
                            <b-button block variant="primary" :href="applyUrl"
                                >Apply for Membership</b-button
                            >
                            <b-button
                                block
                                variant="outline-primary"
                                :to="{ name: 'login' }"
                                >Login</b-button
                            >
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </main>
</template>

<script>
export default {
    data() {
        return {
            applyUrl: `${process.env.MIX_USER_APP_URL}/auth/apply`,
            auth0LoginUrl: `/auth/login`,
        };
    },
};
</script>
